;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface StarFillIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function StarFillIcon({ size = 24, ...props }: StarFillIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Star fill">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19198 2.14006C7.49065 1.42206 8.50932 1.42206 8.80798 2.14006L10.196 5.47806L13.7986 5.76673C14.5746 5.82873 14.8893 6.79673 14.298 7.3034L11.5533 9.65473L12.3913 13.1701C12.572 13.9274 11.7486 14.5254 11.0846 14.1201L7.99998 12.2361L4.91531 14.1201C4.25131 14.5254 3.42798 13.9267 3.60865 13.1701L4.44665 9.65473L1.70198 7.3034C1.11065 6.79673 1.42531 5.82873 2.20131 5.76673L5.80398 5.47806L7.19198 2.14006Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19198 2.14006C7.49065 1.42206 8.50932 1.42206 8.80798 2.14006L10.196 5.47806L13.7986 5.76673C14.5746 5.82873 14.8893 6.79673 14.298 7.3034L11.5533 9.65473L12.3913 13.1701C12.572 13.9274 11.7486 14.5254 11.0846 14.1201L7.99998 12.2361L4.91531 14.1201C4.25131 14.5254 3.42798 13.9267 3.60865 13.1701L4.44665 9.65473L1.70198 7.3034C1.11065 6.79673 1.42531 5.82873 2.20131 5.76673L5.80398 5.47806L7.19198 2.14006Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
